/** Shared Auth0 access-token request options (must match Auth0Provider + API client). */
export function getAuthTokenRequestOptions(): {
  authorizationParams: { audience: string };
} {
  const audience = import.meta.env.VITE_AUTH0_AUDIENCE;
  return { authorizationParams: { audience } };
}
